const CommunityActionTypes = {
  RECEIVE_MEMBERS: 'RECEIVE_MEMBERS',
  LOADING_EVENTS: 'LOADING_EVENTS',
  RECEIVE_EVENTS: 'RECEIVE_EVENTS'
}

export default CommunityActionTypes;
